import axiosInstance from '@/plugins/axios';

export default class ServiceTabelas {
  static listar = () => axiosInstance.get('config-tables/tables');
  static parametrosAnalise = () => axiosInstance.get('config-tables/analysis-parameter');
}
